export default __webpack_public_path__ + "static/media/pp-register2.bb8c13dd.jpg";